import { createContext, useContext, useState } from 'react';
import Notification from 'modules/components/common/notifications/notification';
import PropTypes from 'prop-types';
const PatientsContext = createContext();

export const PatientsProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(false);
  const [nativeToken, setNativeToken] = useState(null);
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [recentSearch, setRecentSearch] = useState(
    JSON?.parse(localStorage.getItem('recentSearch'))
  );

  const handleCloseSnackbar = () => setSnackbarIsOpen(false);
  const handleOpenSnackbar = (text, type) => {
    setSnackbarIsOpen(true);
    setMessage({ text, type });
  };

  const initialValues = {
    phone: '',
    code: '',
    medicalNumber: '',
    nationalCode: ''
  };

  return (
    <PatientsContext.Provider
      value={{
        handleOpenSnackbar,
        recentSearch,
        setRecentSearch,
        initialValues,
        nativeToken,
        setNativeToken,
        userInfo,
        setUserInfo
      }}
    >
      <Notification
        open={snackbarIsOpen}
        autoClose={true}
        showCloseButton={true}
        message={message}
        handleClose={handleCloseSnackbar}
      />
      {children}
    </PatientsContext.Provider>
  );
};

PatientsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const usePatientsContext = () => useContext(PatientsContext);
